import { messages } from './messages';

/**
 * The document title, from the one Georgian catalogue — T007, FR-UX-05.
 *
 * A `<title>` written into `index.html` would be a second place a visible string lives, and the
 * first one to drift. Instead `index.html` carries a placeholder that the build replaces from this
 * module, and the running application sets `document.title` from the same value, so the tab is
 * correct before JavaScript runs and stays correct after it does.
 */

/** The literal `index.html` carries in place of a title. */
export const TITLE_PLACEHOLDER = '%APP_TITLE%';

/** The single source of the title. */
export function documentTitle(): string {
  return messages.app.name;
}

/** Pure, so the build step and its test exercise the same substitution. */
export function applyDocumentTitle(html: string, title: string): string {
  return html.split(TITLE_PLACEHOLDER).join(title);
}
